/* eslint-disable */
import * as React from 'react';
import { Link } from '@thd-olt-component-react/router';
import { Helmet } from 'react-helmet-async';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';

export const Home = () => {
  return (
    <div className="container">
      <div className="grid isBound u--padding">
        <Helmet>
          <title>Home Page</title>
          <link rel="canonical" href="https://www.homedepot.com/" />
        </Helmet>
        <ul className="container__list">
          <li><Link to="/calculator/mulch/">Mulch Calculator</Link></li>
          <li><Link to="/c/moving-box-calculator/">Moving Calculator</Link></li>
        </ul>
      </div>
    </div>
  );
};

Home.propTypes = {
};

Home.displayName = 'HomePage';
Home.defaultProps = {
  name: '',
};
